/* Shade Patch concept B: "Find your Shade Patch" picker. Pills are buttons; the matching recommendation panel is
   shown, the URL keeps ?for=<slug> so menu links and shared links preselect the answer. */
if (!customElements.get('spb-finder')) {
  customElements.define('spb-finder', class extends HTMLElement {
    connectedCallback() {
      this.param = this.dataset.param || 'for';
      this.pills = [...this.querySelectorAll('[data-use]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.hint = this.querySelector('[data-hint]');
      this.result = this.querySelector('[data-result]');
      this.status = document.createElement('p');
      this.status.className = 'spb-sr';
      this.status.setAttribute('role', 'status');
      this.result.prepend(this.status);
      this.pills.forEach((p) => p.addEventListener('click', () => this.select(p.dataset.use, true)));
      const initial = new URL(location.href).searchParams.get(this.param);
      if (initial && this.pills.some((p) => p.dataset.use === initial)) this.select(initial, false, true);
    }
    select(slug, push, scroll) {
      let shown = null;
      this.pills.forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.use === slug)));
      this.panels.forEach((panel) => {
        const on = panel.dataset.panel === slug;
        panel.hidden = !on;
        if (on) shown = panel;
      });
      if (this.hint) this.hint.hidden = !!shown;
      if (shown) this.status.textContent = `Recommended for you: ${shown.querySelector('h2')?.textContent || ''}`;
      if (push) {
        const u = new URL(location.href);
        u.searchParams.set(this.param, slug);
        history.replaceState({}, '', u);
      }
      if (shown && scroll) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        requestAnimationFrame(() => shown.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }));
      }
    }
  });
}
